import {getApplicationLeadButtonText} from "./get_application_lead_button_text";

interface IGetCtaTextParams {
    shouldHidePrices: boolean;
    isDataFetched: boolean;
    propertyId?: number;
    propertyPrice?: number | null;
}

export interface ICtaTextResult {
    propertyHasNoPrice: boolean;
    shouldShowPrice: boolean;
    ctaText: string;
}

export const getApplicationFormBoxCtaText = ({shouldHidePrices, isDataFetched, propertyId, propertyPrice}: IGetCtaTextParams): ICtaTextResult => {
    const propertyHasNoPrice = isDataFetched && !propertyPrice;

    // Incomplete/unauthenticated user should always trigger registration flow
    if (shouldHidePrices) {
        return {propertyHasNoPrice, shouldShowPrice: false, ctaText: "Odkryj cenę"};
    }

    // Complete user should always show lead form with appropriate CTA text
    const ctaText = getApplicationLeadButtonText({
        isPriceHidden: false,
        isProperty: !!propertyId,
        propertyPrice: propertyPrice
    });

    return {propertyHasNoPrice, shouldShowPrice: true, ctaText};
};
import {getApplicationLeadButtonText} from "./get_application_lead_button_text";

interface IGetCtaTextParams {
    shouldHidePrices: boolean;
    isDataFetched: boolean;
    propertyId?: number;
    propertyPrice?: number | null;
}

export interface ICtaTextResult {
    propertyHasNoPrice: boolean;
    shouldShowPrice: boolean;
    ctaText: string;
}

export const getApplicationFormBoxCtaText = ({shouldHidePrices, isDataFetched, propertyId, propertyPrice}: IGetCtaTextParams): ICtaTextResult => {
    const propertyHasNoPrice = isDataFetched && !propertyPrice;

    // Incomplete/unauthenticated user should always trigger registration flow
    if (shouldHidePrices) {
        return {propertyHasNoPrice, shouldShowPrice: false, ctaText: "Odkryj cenę"};
    }

    // Complete user should always show lead form with appropriate CTA text
    const ctaText = getApplicationLeadButtonText({
        isPriceHidden: false,
        isProperty: !!propertyId,
        propertyPrice: propertyPrice
    });

    return {propertyHasNoPrice, shouldShowPrice: true, ctaText};
};
